import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Supplier } from '@app/_models/_DTOs/supplier';

@Injectable({ providedIn: 'root' })
export class SupplierService extends DataService<Supplier> {
    constructor(http: HttpClient) {
        super(http, "api/suppliers")
    }
}